import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { urlHostResolver } from '@/src/lib/utils';
import SolutionsView from '@/src/views/solutions/SolutionsView';

export default function SolutionsPage() {
  return (
    <AssembleLayout Layout={MainLayout} Component={SolutionsView}>
      <NextSeo
        title="Soluções"
        description="Venda online produtos ou serviços educacionais. Baixo investimento, rápida implantação e flexível para venda tanto de produtos quanto serviços de educação."
        openGraph={{
          title: 'Soluções',
          url: urlHostResolver('/solutions'),
        }}
      />
    </AssembleLayout>
  );
}
